module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"hu":{"name":"Szívemben Született Afrika Egyesület","newsletter":"Hírlevél"},"en":{"name":"Africa Born in my Heart Association","newsletter":"Newsletter"}}')
  delete Component.options._Ctor
}
